export { multiOwnerPluginActions } from "./extension.js";
export { MultiOwnerPluginAbi, MultiOwnerPluginExecutionFunctionAbi, } from "./plugin.js";
//# sourceMappingURL=index.js.map